import { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  // {
  //   path: '/',
  //   name: 'gowireless',
  //   component: () => import('pages/GoWireless.vue')
  // },
  // {
  //   path: '/mobile-voice',
  //   name: 'mobilevoice',
  //   component: () => import('pages/MobileVoice.vue')
  // },
  {
    path: '/',
    name: 'servicelist',
    component: () => import('pages/ServiceList.vue')
  },
  {
    path: '/authentication',
    name: 'login-component',
    component: () => import('pages/login.vue')
  },
  {
    path: '/orders-list',
    name: 'orderslist',
    component: () => import('pages/OrdersList.vue')
  },
  {
    path: '/activate',
    name: 'activate',
    component: () => import('pages/Activate.vue')
  },
  {
    path: '/port-out',
    name: 'portout',
    component: () => import('pages/PortOut.vue')
  },
  {
    path: '/port-in',
    name: 'portin',
    component: () => import('pages/PortIn.vue')
  },
  {
    path: '/drop-ship',
    name: 'dropship',
    component: () => import('pages/DropShip.vue')
  },
  {
    path: '/coverage',
    name: 'coverage',
    component: () => import('pages/Coverage.vue')
  },
  {
    path: '/admin/clients',
    name: 'clients',
    component: () => import('pages/Clients.vue')
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default routes
